import PropTypes from 'prop-types';

import MinusIcon from '../icons/MinusThin';
import PlusIcon from '../icons/PlusThin';
import colors from '../themes/colors';
import { AnimationCircle, BUTTON_VARIATIONS, CounterWrapper, DisplayText, StyledButton } from './styles';

const propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  variation: PropTypes.string,
  width: PropTypes.number
};

const defaultProps = {
  disabled: false,
  min: 0,
  max: 999,
  variation: BUTTON_VARIATIONS.LARGE,
  iconColor: colors.pureWhite[0],
  iconDisabledColor: colors.pureWhite[0],
  buttonBG: colors.preciousStoneBlue[100],
  buttonDisabledBG: colors.preciousStoneBlue[100]
};

export const STYLES_VARIATIONS = {
  GREEN_BG: 'GREEN_BG'
};

const MinusButton = ({
  onChange,
  disabled,
  buttonBG,
  buttonDisabledBG,
  isNewWidgetStyleActive,
  variation,
  iconColor,
  iconDisabledColor,
  value
}) => {
  const handleClick = () => {
    if (disabled) return;
    onChange(+value - 1);
  };
  return (
    <StyledButton
      type="button"
      buttonBG={buttonBG}
      buttonDisabledBG={buttonDisabledBG}
      aria-label="decrease"
      aria-disabled={disabled}
      onClick={handleClick}
      variation={variation}>
      {!isNewWidgetStyleActive ? <AnimationCircle id="animation-circle" variation={variation} /> : null}
      <MinusIcon size={getSvgSize(variation)} color={disabled ? iconDisabledColor : iconColor} />
    </StyledButton>
  );
};
const PlusButton = ({
  onChange,
  disabled,
  buttonBG,
  buttonDisabledBG,
  isNewWidgetStyleActive,
  variation,
  iconColor,
  iconDisabledColor,
  value
}) => {
  const handleClick = () => {
    if (disabled) return;
    onChange(+value + 1);
  };
  return (
    <StyledButton
      type="button"
      buttonBG={buttonBG}
      buttonDisabledBG={buttonDisabledBG}
      aria-label="increase"
      aria-disabled={disabled}
      onClick={handleClick}
      variation={variation}>
      {!isNewWidgetStyleActive ? <AnimationCircle id="animation-circle" variation={variation} /> : null}
      <PlusIcon size={getSvgSize(variation)} color={disabled ? iconDisabledColor : iconColor} />
    </StyledButton>
  );
};
/** Default Counter component*/
const Counter = ({
  isNewWidgetStyleActive = false,
  fontSize,
  lineHeight,
  color,
  disabled,
  value,
  onChange,
  min,
  max,
  disableIncrease,
  variation = BUTTON_VARIATIONS.LARGE,
  width,
  buttonBG,
  buttonDisabledBG,
  iconColor,
  iconDisabledColor,
  styleVariation
}) => {
  const canBeDecreased = value > min;
  const canBeIncreased = value < max;

  return (
    <CounterWrapper isNewWidgetStyleActive={isNewWidgetStyleActive} styleVariation={styleVariation}>
      <MinusButton
        onChange={onChange}
        disabled={!canBeDecreased || disabled}
        buttonBG={buttonBG}
        buttonDisabledBG={buttonDisabledBG}
        canBeDecreased={canBeDecreased}
        isNewWidgetStyleActive={isNewWidgetStyleActive}
        variation={variation}
        iconColor={iconColor}
        iconDisabledColor={iconDisabledColor}
        value={value}
      />

      <DisplayText color={color} lineHeight={lineHeight} fontSize={fontSize} variation={variation} width={width}>
        {+value}
      </DisplayText>

      <PlusButton
        onChange={onChange}
        disabled={!canBeIncreased || disabled || disableIncrease}
        buttonBG={buttonBG}
        buttonDisabledBG={buttonDisabledBG}
        isNewWidgetStyleActive={isNewWidgetStyleActive}
        variation={variation}
        iconColor={iconColor}
        iconDisabledColor={iconDisabledColor}
        value={value}
      />
    </CounterWrapper>
  );
};

Counter.VARIANTS = STYLES_VARIATIONS;
Counter.propTypes = propTypes;
Counter.defaultProps = defaultProps;

export default Counter;

function getSvgSize(variation) {
  return variation === BUTTON_VARIATIONS.LARGE ? '32px' : '24px';
}
